

import VideoPlayer from "./videoplayer";
import EditSubtitle from "../../../applications/appcode/appcomponents/subtitles/editsubtitle/edit-subtitle";
import Lisibility from "../../../applications/appcode/appcomponents/lisibility/lisibility";
import "./videoplayer.css"
import React from "react";

class VideoPlayerST extends VideoPlayer {


  constructor(props) {
    super(props);

    this.editSubtitleRef = React.createRef();
    this.lisibilityRef = React.createRef();
    this.state.currentSubtitle = null;

    this.mode = "apply";
    
    this.onChange = this.onChange.bind(this);
    this.onUpdateSubtitleOnState = this.onUpdateSubtitleOnState.bind(this);

  }
  
  componentDidMount() {
    super.componentDidMount();
    
    this.setState({ modeA: this.props.modeA, modeB: this.props.modeB, modeC: this.props.modeC });
  }

  componentDidUpdate(prevProps, prevState) {
    

   if (prevProps.modeA !== this.props.modeA) {
      this.setState({ modeA: this.props.modeA });
    }

    if (prevProps.modeB !== this.props.modeB){
      this.setState({ modeB: this.props.modeB });
    }

    if (prevProps.modeC !== this.props.modeC){
      this.setState({ modeC: this.props.modeC });
    }

      if (this.state.isPlaying !== prevState.isPlaying) {
      this.props.onChangeIsPlaying(this.state.isPlaying);
    }

  if (this.state.lastCurrentTime !== prevState.lastCurrentTime) {
      const sTimecode = this.GetLocalTimeCodeSecond(this.state.lastCurrentTime);    
      this.props.onChangeSubtitle(sTimecode);
    }
  }

  onChange(subtitle) {
    this.onUpdateSubtitleOnState(subtitle);
          
    this.props.onChange(subtitle, 'editSubtitle');
  }

  onUpdateSubtitleOnState(subtitle) {
    this.setState({ currentSubtitle: subtitle });
  }
  
  getExtraRender() {

    //if ((this.editSubtitleRef) && (this.editSubtitleRef.current))
    //  console.log ("current = ", this.editSubtitleRef.current.getSubtitleDisplayed());

    return (<><div className="player-layer-extra">

      <EditSubtitle
        ref={this.editSubtitleRef}
        onChange={this.onChange}
        onMove={(id, timecode) =>
          this.props.onMove(id, timecode, 'editSubtitle')
        }
        onSave={this.props.onSave}
        playerParams={this.props.params}
        subtitleParameters={this.props.subtitleParameters}
        displayParameters={this.props.displayParameters}
        applicationsparams =  {this.props.applicationsparams}
        undo={this.props.undo}
        redo={this.props.redo}
        readOnly={this.props.readOnly}
        isPlaying={this.state.isPlaying && this.state.modeC}
        addNewActionForUndo={this.props.addNewActionForUndo}
        onUndoOrRedo={(key, action) =>
          this.props.onUndoOrRedo(key, action, 'editSubtitle')
        }
        onProcessShortcutToEditListSubtitle={this.props.onProcessShortcutToEditListSubtitle}
        showSubtitleNumber={this.props.showSubtitleNumber}
        videoDimensions={{
          videostartx: this.state.videostartx,
          videostarty: this.state.videostarty, 
          videowidthx: this.state.videowidthx,
          videoheighty: this.state.videoheighty
        }}
        onUpdateSubtitleOnState={this.onUpdateSubtitleOnState}
        grammalecte={this.props.grammalecte}
        showTimecodes={this.props.showTimecodes}
        timecode={this.props.timecode}
        getTimeCodeString={this.props.getTimeCodeString}
        getIntervalString={this.props.getIntervalString}
        getSubtitles={this.props.getSubtitles}
      />
    <div className="player-layer-lisibility">
      <Lisibility 
        ref={this.lisibilityRef}  
        isPlaying = {false}
        stparams = {this.props.subtitleParameters}
        subtitle = {this.state.currentSubtitle}
        simplified = {false}
        
      />
    </div>



    </div>
    </>
  )


  }


  // *******************************************
  // functions pures
  // *******************************************
  childDrawVideoToCanvas(timecode) {
  }
  childRedrawCurrentFrame(timecode) {
  }
}

VideoPlayerST.defaultProps = 
{
    mode: "subtitling",
    timecode: {
      isTyping: false,
      isTimeCodeOut: false,
      newTimeCodeString: null,
      value: null,
    },
}

export default VideoPlayerST